import React, { useState } from "react";
import { Card, Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { useAppContext } from "../../services/context";

const LineGraph = () => {
  const { state } = useAppContext();
  const { dashboardData } = state;
  const [filter, setFilter] = useState("day");
  const lineGraph = {
    labels:
      filter === "day"
        ? dashboardData?.donations?.daily?.map((m) => m.date) || [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
          ]
        : filter === "week"
          ? ["Week 1", "Week 2", "Week 3", "Week 4"]
          : dashboardData?.donations?.monthly?.map((m) => m.month) || [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ],
    datasets: [
      {
        label: "Donations",
        data:
          filter === "day"
            ? dashboardData?.donations?.daily?.map((m) => m.donations) || []
            : filter === "week"
              ? dashboardData?.donations?.weekly?.map((m) => m.donations) || []
              : dashboardData?.donations?.monthly?.map((m) => m.donations) ||
                [],
        borderColor: "#28a745",
        backgroundColor: "rgba(40, 167, 69, 0.2)",
        fill: true,
      },
      {
        label: "Users",
        data:
          filter === "day"
            ? dashboardData?.users_trafic?.daily?.map((m) => m.userCount) || []
            : filter === "week"
              ? dashboardData?.users_trafic?.weekly?.map((m) => m.userCount) ||
                []
              : dashboardData?.users_trafic?.monthly?.map((m) => m.userCount) ||
                [],
        borderColor: "#17a2b8",
        backgroundColor: "rgba(23, 162, 184, 0.2)",
        fill: true,
      },
    ],
  };
  return (
    <div>
      <Row className="mb-4">
        <Col>
          <DropdownButton
            id="dropdown-basic-button"
            className="btn-success text-white"
            title={`Filter by ${filter}`}
            onSelect={(e) => setFilter(e)}
            style={{
              borderRadius: "30px",
              padding: "10px 20px",
              fontSize: "1.1rem",
            }}
          >
            <Dropdown.Item eventKey="day">Day</Dropdown.Item>
            <Dropdown.Item eventKey="week">Week</Dropdown.Item>
            <Dropdown.Item eventKey="month">Month</Dropdown.Item>
          </DropdownButton>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card
            className="bg-dark text-white mb-4"
            style={{
              borderRadius: "15px",
            }}
          >
            <Card.Body
              className="d-flex flex-column"
              style={{ padding: "20px" }}
            >
              <Card.Title>Donations and Users Traffic ({filter})</Card.Title>
              <div style={{ flex: 1, overflow: "hidden" }}>
                <Line
                  data={lineGraph}
                  options={{ maintainAspectRatio: false }}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LineGraph;
